import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgGbpc = function SvgGbpc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd",
        clipPath: "url(#clip0_890_303)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#2775CA",
        d: "M60 0c33.137 0 60 26.863 60 60s-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M73.71 17.752c-1.353-.433-2.46.37-2.46 1.79v3.494c0 .953.718 2.037 1.612 2.364C87.223 30.66 97.5 44.464 97.5 60.625S87.223 90.59 72.862 95.85c-.98.359-1.612 1.32-1.612 2.364v3.493c0 1.421 1.106 2.224 2.46 1.792C91.857 97.7 105 80.697 105 60.625S91.858 23.55 73.71 17.752M48.75 19.543c0-1.42-1.106-2.224-2.46-1.791C28.143 23.55 15 40.552 15 60.625S28.142 97.7 46.29 103.5c1.354.432 2.46-.371 2.46-1.792v-3.493c0-.953-.718-2.037-1.612-2.364C32.777 90.59 22.5 76.786 22.5 60.625c0-16.16 10.277-29.965 24.638-35.225.894-.327 1.612-1.411 1.612-2.364z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m76.91 78.75-1.304-2.05c-.696-1.094-2.142-1.429-3.223-.746-.898.568-2.269 1.199-3.704.985l-.369-.054c-.993-.142-2.493-.358-4.459-.928-2.11-.675-3.995-1.017-5.6-1.017-1.14 0-2.278.142-3.4.422l.252-.303c2.64-3.144 3.98-6.06 3.98-8.668v-.064c0-.944-.19-2.088-.564-3.41h5.979a2.36 2.36 0 0 0 2.36-2.36v-.99a2.363 2.363 0 0 0-2.36-2.36H56.12l-.726-1.27-.553-.92c-.285-.53-.51-.981-.682-1.364l-.084-.167c-.855-1.633-1.289-3.192-1.289-4.636v-.063c0-1.343.297-2.546.884-3.573 1.346-2.354 3.664-3.499 7.086-3.499 6.37 0 7.559 4.797 7.7 7.656a2.354 2.354 0 0 0 2.355 2.238h3.029c.655 0 1.264-.261 1.714-.737s.679-1.1.642-1.756c-.135-2.46-.584-5.801-1.946-7.753l-1.124-1.648-.033-.044c-2.86-3.414-6.925-5.145-12.08-5.145h-.064c-4.129 0-7.749 1.203-10.76 3.575-3.687 2.902-5.556 6.691-5.556 11.263v.643c0 .534.05 1.042.144 1.47.204 1.308 1.007 3.188 2.449 5.73h-2.032a2.363 2.363 0 0 0-2.36 2.36v.99a2.36 2.36 0 0 0 2.36 2.36h5.162c.723 1.35 1.088 2.668 1.088 3.923v.13c0 .5-.09 1.002-.176 1.489-.044.246-.087.49-.12.731-.456 3.351-4.582 6.968-6.335 8.368a2.357 2.357 0 0 0-.437 3.233l1.622 2.23a2.366 2.366 0 0 0 3.09.654c1.29-.734 3.291-1.61 5.5-1.61 1.29 0 2.596.217 3.866.64l1.249.459c3.65 1.232 6.512 1.858 8.506 1.858 3.33 0 6.493-1.935 8.083-3.088a2.37 2.37 0 0 0 .616-3.184"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_890_303"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h120v120H0z"
    })))));
};

export { SvgGbpc as ReactComponent };
//# sourceMappingURL=GBPC.svg.es.js.map
